// Config Manager
// tslint:disable:no-console
import { rtcVersion } from './version';
export var _configs = {
    name: 'JiveRTC',
    logging: true,
    environment: 'default',
    socketUrl: 'default',
    notificationUrl: 'default',
    gatewayVersion: 'v3',
    gatewayEnvironment: 'webrtc',
    notificationVersion: 'v1',
    gatewayBranch: '',
    notificationBranch: '',
    iceServers: [
        { urls: ['stun:turn.goto-rtc.com:3478'], username: 'citrixturnuser', credential: 'turnpassword' },
        {
            urls: [
                'turn:turn.goto-rtc.com:3478?transport=udp',
                'turn:turn.goto-rtc.com:443?transport=tcp',
                'turn:turn.goto-rtc.com:3478?transport=tcp',
            ],
            username: 'citrixturnuser',
            credential: 'turnpassword',
        }
    ],
    SCREEN_SHARE_FRAME_RATE: 24,
    VOICE_ACTIVITY_LEVELS: 6,
    VOICE_ACTIVITY_POLL_INTERVAL: 70,
    AVAILABLE_DEVICES_POLL_INTERVAL_TIME: 3000,
    AVAILABLE_DEVICE_POLL_INITIAL_DELAY: 0,
    REQUEST_TIMEOUT: 10000,
    DEFAULT_NOTIFICATION_CHANNEL_LIFETIME: 3600,
    HTTP_CONNECTION_TIMEOUT: 4000,
    DISCONNECTED_TIMEOUT: 1000,
    PING_INTERVAL: 8000,
    PING_TIMEOUT: 4000,
    DTMF_SOUND_DELAY: 800,
    POLLING_INTERVAL_CONFERENCE: 15000,
    LIFETIME_MIN_RECONNECT_DELAY: 2000,
    LIFETIME_MAX_RECONNECT_DELAY: 60000,
    LIFETIME_RECONNECT_DECAY: 1.3,
    LIFETIME_CONNECTION_TIMEOUT: 4000,
    LIFETIME_MAX_RECONNECT_ATTEMPTS: Infinity,
    LONG_POLLING_INTERVAL: 30000,
    CHANNEL_DOWN_POLLING_INTERVAL: 5000,
    STATS_CHECK_INTERVAL: 2500,
    get version() {
        return rtcVersion;
    },
    get browser() {
        return {
            'chrome': '52',
            'firefox': '48',
            'opera': '39',
            'safari': 'none',
            'ie': 'none',
            'edge': 'none'
        };
    },
    get socketUrlList() {
        return {
            'default': 'wss://webrtc.jive.com/',
            'staging': 'wss://webrtc.staging.jive.com/',
            'dev': 'wss://webrtc.dev.jive.com/',
            'dfw': 'wss://199.36.251.28/',
            'atl': 'wss://162.250.62.28/',
            'nyc': 'wss://162.250.61.28/',
            'lax': 'wss://162.250.60.28/',
            'las': 'wss://199.36.250.28/',
            'ord': 'wss://199.87.121.28/',
            'geg': 'wss://api.staging.jive.com/',
            'pvu': 'wss://api.dev.jive.com/'
        };
    },
    get notificationUrlList() {
        return {
            'default': 'https://webrtc.jive.com/notification-channel/',
            'staging': 'https://webrtc.staging.jive.com/notification-channel/',
            'dev': 'https://webrtc.dev.jive.com/notification-channel/',
            'dfw': 'https://199.36.251.28/notification-channel/',
            'atl': 'https://162.250.62.28/notification-channel/',
            'nyc': 'https://162.250.61.28/notification-channel/',
            'lax': 'https://162.250.60.28/notification-channel/',
            'las': 'https://199.36.250.28/notification-channel/',
            'ord': 'https://199.87.121.28/notification-channel/',
            'geg': 'https://api.staging.jive.com/notification-channel/',
            'pvu': 'https://api.dev.jive.com/notification-channel/'
        };
    },
    get analyticsList() {
        return {
            'default': 'UA-143909-20',
            'staging': 'UA-143909-27',
            'dev': '',
        };
    }
};
var ConfigsManager = /** @class */ (function () {
    function ConfigsManager() {
    }
    Object.defineProperty(ConfigsManager, "appName", {
        get: function () {
            return _configs.name;
        },
        set: function (name) {
            _configs.name = name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "logging", {
        get: function () {
            return _configs.logging;
        },
        set: function (enable) {
            _configs.logging = enable;
        },
        enumerable: true,
        configurable: true
    });
    ConfigsManager.disableLogging = function () {
        _configs.logging = false;
    };
    ConfigsManager.enableLogging = function () {
        _configs.logging = true;
    };
    Object.defineProperty(ConfigsManager, "environment", {
        get: function () {
            return _configs.environment;
        },
        set: function (environment) {
            _configs.environment = environment;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "socketUrl", {
        get: function () {
            var environment = this.gatewayEnvironment !== '' ? this.gatewayEnvironment : 'webrtc';
            if (this.gatewayBranch !== '') {
                console.log(_configs.socketUrlList[_configs.socketUrl] + environment + '/' + this.gatewayBranch + '/sessions');
                return _configs.socketUrlList[_configs.socketUrl] + environment + '/' + this.gatewayBranch + '/sessions';
            }
            return _configs.socketUrlList[_configs.socketUrl] + environment + '/' + this.gatewayVersion + '/sessions';
        },
        set: function (name) {
            _configs.socketUrl = name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "notificationUrl", {
        get: function () {
            if (this.notificationBranch !== '') {
                console.log(_configs.notificationUrlList[_configs.notificationUrl] + 'workspace/' + this.notificationBranch);
                return _configs.notificationUrlList[_configs.notificationUrl] + 'workspace/' + this.notificationBranch;
            }
            return _configs.notificationUrlList[_configs.notificationUrl] + this.notificationVersion;
        },
        set: function (name) {
            _configs.notificationUrl = name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "gatewayVersion", {
        get: function () {
            return _configs.gatewayVersion;
        },
        set: function (version) {
            _configs.gatewayVersion = version;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "gatewayEnvironment", {
        get: function () {
            return _configs.gatewayEnvironment;
        },
        set: function (environment) {
            if (environment && environment !== '') {
                _configs.gatewayEnvironment = environment;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "notificationVersion", {
        get: function () {
            return _configs.notificationVersion;
        },
        set: function (version) {
            _configs.notificationVersion = version;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "notificationBranch", {
        get: function () {
            return _configs.notificationBranch;
        },
        set: function (branch) {
            _configs.notificationBranch = branch;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "gatewayBranch", {
        get: function () {
            return _configs.gatewayBranch;
        },
        set: function (branch) {
            _configs.gatewayBranch = branch;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "iceServers", {
        get: function () {
            return _configs.iceServers;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "version", {
        get: function () {
            return _configs.version;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "browser", {
        get: function () {
            return _configs.browser;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "analytics", {
        get: function () {
            return _configs.analyticsList[_configs.environment];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "configs", {
        get: function () {
            return _configs;
        },
        set: function (config) {
            try {
                Object.assign(_configs, config);
            }
            catch (error) {
                console.error("RTCJS -> Configs not set properly: " + JSON.stringify(error));
            }
            console.log('RTCJS -> Configs set properly:');
            console.log(_configs);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "VOICE_ACTIVITY_LEVELS", {
        get: function () {
            return _configs.VOICE_ACTIVITY_LEVELS;
        },
        set: function (levels) {
            _configs.VOICE_ACTIVITY_LEVELS = levels;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "VOICE_ACTIVITY_POLL_INTERVAL", {
        get: function () {
            return _configs.VOICE_ACTIVITY_POLL_INTERVAL;
        },
        set: function (interval) {
            _configs.VOICE_ACTIVITY_POLL_INTERVAL = interval;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "AVAILABLE_DEVICES_POLL_INTERVAL_TIME", {
        get: function () {
            return _configs.AVAILABLE_DEVICES_POLL_INTERVAL_TIME;
        },
        set: function (interval) {
            _configs.AVAILABLE_DEVICES_POLL_INTERVAL_TIME = interval;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "AVAILABLE_DEVICE_POLL_INITIAL_DELAY", {
        get: function () {
            return _configs.AVAILABLE_DEVICE_POLL_INITIAL_DELAY;
        },
        set: function (t) {
            _configs.AVAILABLE_DEVICE_POLL_INITIAL_DELAY = t;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "REQUEST_TIMEOUT", {
        get: function () {
            return _configs.REQUEST_TIMEOUT;
        },
        set: function (time) {
            _configs.REQUEST_TIMEOUT = time;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "DEFAULT_NOTIFICATION_CHANNEL_LIFETIME", {
        get: function () {
            return _configs.DEFAULT_NOTIFICATION_CHANNEL_LIFETIME;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "HTTP_CONNECTION_TIMEOUT", {
        get: function () {
            return _configs.HTTP_CONNECTION_TIMEOUT;
        },
        set: function (time) {
            _configs.HTTP_CONNECTION_TIMEOUT = time;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "DISCONNECTED_TIMEOUT", {
        get: function () {
            return _configs.DISCONNECTED_TIMEOUT;
        },
        set: function (time) {
            _configs.DISCONNECTED_TIMEOUT = time;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "PING_INTERVAL", {
        get: function () {
            return _configs.PING_INTERVAL;
        },
        set: function (time) {
            _configs.PING_INTERVAL = time;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "PING_TIMEOUT", {
        get: function () {
            return _configs.PING_TIMEOUT;
        },
        set: function (time) {
            _configs.PING_TIMEOUT = time;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "DTMF_SOUND_DELAY", {
        get: function () {
            return _configs.DTMF_SOUND_DELAY;
        },
        set: function (time) {
            _configs.DTMF_SOUND_DELAY = time;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "LIFETIME_MIN_RECONNECT_DELAY", {
        get: function () {
            return _configs.LIFETIME_MIN_RECONNECT_DELAY;
        },
        set: function (c) {
            _configs.LIFETIME_MIN_RECONNECT_DELAY = c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "LIFETIME_MAX_RECONNECT_DELAY", {
        get: function () {
            return _configs.LIFETIME_MAX_RECONNECT_DELAY;
        },
        set: function (c) {
            _configs.LIFETIME_MAX_RECONNECT_DELAY = c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "LIFETIME_RECONNECT_DECAY", {
        get: function () {
            return _configs.LIFETIME_RECONNECT_DECAY;
        },
        set: function (c) {
            _configs.LIFETIME_RECONNECT_DECAY = c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "LIFETIME_CONNECTION_TIMEOUT", {
        get: function () {
            return _configs.LIFETIME_CONNECTION_TIMEOUT;
        },
        set: function (c) {
            _configs.LIFETIME_CONNECTION_TIMEOUT = c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "LIFETIME_MAX_RECONNECT_ATTEMPTS", {
        get: function () {
            return _configs.LIFETIME_MAX_RECONNECT_ATTEMPTS;
        },
        set: function (c) {
            _configs.LIFETIME_MAX_RECONNECT_ATTEMPTS = c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "CHANNEL_DOWN_POLLING_INTERVAL", {
        get: function () {
            return _configs.CHANNEL_DOWN_POLLING_INTERVAL;
        },
        set: function (c) {
            _configs.CHANNEL_DOWN_POLLING_INTERVAL = c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "LONG_POLLING_INTERVAL", {
        get: function () {
            return _configs.LONG_POLLING_INTERVAL;
        },
        set: function (c) {
            _configs.LONG_POLLING_INTERVAL = c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "STATS_CHECK_INTERVAL", {
        get: function () {
            return _configs.STATS_CHECK_INTERVAL;
        },
        set: function (c) {
            _configs.STATS_CHECK_INTERVAL = c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigsManager, "SCREEN_SHARE_FRAME_RATE", {
        get: function () {
            return _configs.SCREEN_SHARE_FRAME_RATE;
        },
        set: function (c) {
            _configs.SCREEN_SHARE_FRAME_RATE = c;
        },
        enumerable: true,
        configurable: true
    });
    return ConfigsManager;
}());
export { ConfigsManager };
export default ConfigsManager;
//# sourceMappingURL=configs.js.map